const PRODUCT_IMAGE_SIZE = 1800;
const FALLBACK_PRODUCT_IMAGE_URL =
  "https://pocket-rocket-customers.s3.eu-central-1.amazonaws.com/indyvit/indyvit-asset.png";

const assetLanguage = (language) => (language === "nl" ? "en" : language || "de");

const productBaseAssetPath = (order, language) => {
  const languagePath = assetLanguage(language);

  if (order?.labelPattern) {
    return `/assets/label/${languagePath}/pattern/${order.labelPattern}.png`;
  }

  return `/assets/label/${languagePath}/${order?.labelColor || "red"}.png`;
};

const capsuleAssetPath = (order) => `/assets/capsule/${order?.capsuleColor || "white"}.png`;

const loadImage = (src) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });
};

const fitText = (ctx, text, maxWidth, initialFontSize) => {
  let fontSize = initialFontSize;

  do {
    ctx.font = `${fontSize}px "Groteska Medium", "Roc Grotesk", Arial, sans-serif`;
    fontSize -= 1;
  } while (fontSize > 18 && ctx.measureText(text).width > maxWidth);
};

const drawLabelText = (ctx, name, labelFontSize) => {
  const text = (name || "").trim();

  if (!text) {
    return;
  }

  ctx.save();
  ctx.translate(712, 1128);
  ctx.rotate((-91 * Math.PI) / 180);
  ctx.transform(1, 0, Math.tan((-20 * Math.PI) / 180), 1, 0, 0);
  ctx.fillStyle = "#000";
  ctx.textBaseline = "middle";
  fitText(ctx, text, 255, Math.max(labelFontSize || 36, 34) * 2.1);
  ctx.fillText(text, 0, 0);
  ctx.restore();
};

export default {
  createProductImage: async function (order, language) {
    if (typeof document === "undefined" || !document.createElement) {
      return null;
    }

    const canvas = document.createElement("canvas");
    canvas.width = PRODUCT_IMAGE_SIZE;
    canvas.height = PRODUCT_IMAGE_SIZE;

    const ctx = canvas.getContext("2d");
    const [productBase, capsule] = await Promise.all([
      loadImage(productBaseAssetPath(order, language)),
      loadImage(capsuleAssetPath(order)),
    ]);

    ctx.clearRect(0, 0, PRODUCT_IMAGE_SIZE, PRODUCT_IMAGE_SIZE);
    ctx.drawImage(productBase, 0, 0, PRODUCT_IMAGE_SIZE, PRODUCT_IMAGE_SIZE);
    ctx.drawImage(capsule, 0, 0, PRODUCT_IMAGE_SIZE, PRODUCT_IMAGE_SIZE);
    drawLabelText(ctx, order?.name, order?.labelFontSize);

    return canvas.toDataURL("image/png");
  },
  fallbackProductImageUrl: function (order, language) {
    if (typeof window === "undefined" || !window.location?.origin) {
      return FALLBACK_PRODUCT_IMAGE_URL;
    }

    return `${window.location.origin}${productBaseAssetPath(order, language)}`;
  },
};
